import { Button } from '@/components/button';
import { Text } from '@/components/text';
import { tv } from '@/utils/styles';

interface DashboardEmptyProps {
  title: string;
  cta: string;
  href: string;
}

const DashboardEmpty = ({ title, cta, href }: DashboardEmptyProps) => {
  const { base } = styles();

  return (
    <div className={base()}>
      <div className="-mt-4 text-center">
        <Text variant="secondary" className="m-0">
          {title}
        </Text>
        <Button variant="link" className="text-baseSm" href={href}>
          {cta}
        </Button>
      </div>
    </div>
  );
};

export const styles = tv({
  slots: {
    base: 'absolute bottom-0 left-0 right-0 top-0 grid h-full w-full place-items-center text-grey-500',
  },
});

export { DashboardEmpty };
